module.exports = __webpack_public_path__ + "img/ic-pingpong.c44bd32d.svg";